// プレビュー用のスライダー
const TOP_COLLECTION_SLIDE = document.querySelectorAll(
  ".custom-top-collection-swiper .swiper-slide",
);

// ホバー用のスライダー
const TOP_COLLECTION_HOVER_VIEW = document.querySelector("#custom-top-collection-hover-view");

// 一定時間hoverさせてから発火
let hoverTimer = null;
const HOVER_TIME = 100;

// アニメーション用クラス
const CLASS_TOP_COLLECTION_SLIDE_ACTIVE = "js-top-collection-hover-view-active";

TOP_COLLECTION_SLIDE.forEach(function (slide) {
  // const SLIDE_INDEX = parseInt(slide.dataset.swiperSlideIndex, )

  slide.addEventListener("mouseenter", function (e) {
    hoverTimer = setTimeout(function () {
      // リンク
      const URL = e.target.dataset.productUrl;
      const HOVER_VIEW_LINK = TOP_COLLECTION_HOVER_VIEW.querySelector(
        ".custom-top-collection-hover-view__link",
      );
      HOVER_VIEW_LINK.setAttribute("href", URL);

      // 画像
      const FEATURED_IMAGE = e.target.dataset.productFeaturedImage;
      const HOVER_VIEW_IMG = TOP_COLLECTION_HOVER_VIEW.querySelector(
        ".custom-top-collection-hover-view__img",
      );
      HOVER_VIEW_IMG.setAttribute("src", FEATURED_IMAGE);

      // 商品タイトル
      const TITLE = e.target.dataset.productTitle;
      const HOVER_VIEW_TITLE = TOP_COLLECTION_HOVER_VIEW.querySelector(
        ".custom-top-collection-hover-view__title",
      );
      HOVER_VIEW_TITLE.textContent = TITLE;

      // 金額
      const PRICE = e.target.dataset.productPrice;
      const PRICE_COMPARE = e.target.dataset.productCompareAtPrice;
      const HOVER_VIEW_PRICE = TOP_COLLECTION_HOVER_VIEW.querySelector(
        ".custom-top-collection-hover-view__price-container",
      );

      HOVER_VIEW_PRICE.textContent = "";

      if (PRICE_COMPARE > PRICE) {
        HOVER_VIEW_PRICE.insertAdjacentHTML(
          "afterbegin",
          `
            <span class="custom-price-item custom-price-item--sale-regular">
              <s class="custom-price-item__s">
                <span class="custom-price-item__s-text">${PRICE_COMPARE}</span>
              </s>
            </span>
            <span class="custom-price__arrow">→</span>
            <span class="custom-price-item custom-price-item--sale">
              ${PRICE}
            </span>
        `,
        );
      } else {
        HOVER_VIEW_PRICE.insertAdjacentHTML(
          "afterbegin",
          `
            <span class="custom-price-item custom-price-item--regular">
              ${PRICE}
            </span>
        `,
        );
      }
      // HOVER_VIEW_PRICE.textContent = PRICE;

      HOVER_VIEW_IMG.addEventListener("load", function () {
        // hover前のコンテンツの位置取得
        const PREVIEW_RECT = e.target.getBoundingClientRect();
        const PREVIEW_RECT_WIDTH = PREVIEW_RECT.width;
        const PREVIEW_RECT_HEIGHT = PREVIEW_RECT.height;
        const PREVIEW_X = PREVIEW_RECT.left;
        const PREVIEW_Y = PREVIEW_RECT.top + window.pageYOffset;

        // hoverした時のコンテンツのサイズ取得
        const HOVER_VIEW_RECT_VIEW_RECT = TOP_COLLECTION_HOVER_VIEW.getBoundingClientRect();
        const HOVER_VIEW_RECT_VIEW_WIDTH = HOVER_VIEW_RECT_VIEW_RECT.width;
        const HOVER_VIEW_RECT_VIEW_HEIGHT = HOVER_VIEW_RECT_VIEW_RECT.height;

        // REVIEWの中央に重なるように計算
        // 最後の要素の場合は、画面外にはみ出さないように調整
        const HOVER_VIEW_X =
          e.target.dataset.swiperSlideIsEnd === "true"
            ? PREVIEW_X - (HOVER_VIEW_RECT_VIEW_WIDTH - PREVIEW_RECT_WIDTH)
            : PREVIEW_X - (HOVER_VIEW_RECT_VIEW_WIDTH - PREVIEW_RECT_WIDTH) / 2;

        const HOVER_VIEW_Y = PREVIEW_Y - (HOVER_VIEW_RECT_VIEW_HEIGHT - PREVIEW_RECT_HEIGHT) / 2;

        TOP_COLLECTION_HOVER_VIEW.style.top = `${HOVER_VIEW_Y}px`;
        TOP_COLLECTION_HOVER_VIEW.style.left = `${HOVER_VIEW_X}px`;

        TOP_COLLECTION_HOVER_VIEW.classList.add(CLASS_TOP_COLLECTION_SLIDE_ACTIVE);
      });
    }, HOVER_TIME);

    e.target.addEventListener("mouseleave", function (e) {
      clearTimeout(hoverTimer);
    });
  });
});

TOP_COLLECTION_HOVER_VIEW.addEventListener("mouseleave", function () {
  TOP_COLLECTION_HOVER_VIEW.classList.remove(CLASS_TOP_COLLECTION_SLIDE_ACTIVE);
});
